var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.div.rows)?_c('div',{staticClass:"portal-content-wrap ptBG2",staticStyle:{"padding-top":"30px"}},[_c('div',{staticClass:"maxWidth"},_vm._l((_vm.div.rows),function(item,index){return _c('WebPartPageRow',{key:index,attrs:{"row":item,"templateName":_vm.templateName}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }